import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { shellRoute } from './index'
import { inboxSearchSchema } from '../search'

export const inboxRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/inbox',
  validateSearch: inboxSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/inbox'), 'InboxPage'),
})
